import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Flex,
  Grid,
  GridItem,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  Textarea,
  Tooltip,
} from "@chakra-ui/react";
import { DocIcon, EyeIcon, RemoveIcon } from "../../assets/svgs/Icons";
import { statesList } from "../../Common/utils";
import { MultiSelect } from "chakra-multiselect";
import { TiDelete } from "react-icons/ti";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { getProcess } from "../../api";
import dompurify from "dompurify";

function RcForm2({
  values,
  processValues,
  setProcessValues,
  selectedProcessValue,
  setSelectedProcessValue,
  customProcessValue,
  setCustomProcessValue,
  programValues,
  selectedProgramValue,
  setSelectedProgramValue,
  customProgramValue,
  setCustomProgramValue,
  programIds,
  setProgramIds,
  units,
  setUnits,
  unitValues,
  setUnitValues,
  rc2error2,
  setRc2Error2,
  setRc2Error1,
  rc2error1,
  setRc2Error3,
  setRc2Error4,
  setRc2Error5,
  setRc2Error6,
  rc2error3,
  rc2error4,
  rc2error5,
  rc2error6,
  rc2error7,
  setRc2Error7,
  setSelectedUnitProcess,
  selectedUnitProcess,
  suggestions,
  setOpenSuggestions,
  setSuggestions,
  openSuggestions,
  coordinates,
  setCoordinates,
  setUnitAddress,
  unitAddress,
  isSecondChecked,
  setIsSecondChecked,
  handleChange,
  unitTypes,
  setUnitTypes,
}) {
  const programOptions = ["NICE", "GCC", "ETC", "BTC", "BTS"];

  const handleCheckboxChange = (event) => {
    setIsSecondChecked(event.target.checked);

    if (event.target.checked) {
      setUnitValues({
        ...unitValues,
        name: dompurify.sanitize(values.organizationName),
        raw_address: dompurify.sanitize(values.organizationRawAddress),
        city: dompurify.sanitize(values.organizationCity),
        state: dompurify.sanitize(values.organizationState),
        pinCode: values.organizationPinCode,
        country: dompurify.sanitize(values.organizationCountry),
      });
    } else {
      setUnitValues({
        ...unitValues,
        name: "",
        raw_address: "",
        city: "",
        state: "",
        pinCode: "",
        country: "",
      });
    }
  };

  const addUnits = (unitValues) => {
    if (unitValues.unitType === "MAIN") {
      setUnitTypes([
        "FACILITY",
        "INTERNAL SUBCONTRACTOR",
        "EXTERNAL SUBCONTRACTOR",
      ]);
    }

    if (unitValues?.name?.trim() === "") {
      setRc2Error1(true);
    }
    if (unitValues?.raw_address?.trim() === "") {
      setRc2Error7(true);
    }
    if (unitValues?.unitType?.trim() === "") {
      setRc2Error2(true);
    }

    if (unitValues?.state === "") {
      setRc2Error4(true);
    }

    if (unitValues?.numberOfEmployees <= 0) {
      setRc2Error3(true);
    }

    if (!(selectedProcessValue?.length > 0)) {
      setRc2Error5(true);
    }

    if (!(selectedProgramValue?.length > 0)) {
      setRc2Error6(true);
    }

    if (
      unitValues.name.trim() !== "" &&
      unitValues.unitType.trim() !== "" &&
      unitValues.raw_address.trim() !== "" &&
      unitValues.state !== "" &&
      unitValues.numberOfEmployees > 0 &&
      selectedProcessValue?.length > 0 &&
      selectedProgramValue?.length > 0
    ) {
      const unitObject = {
        id: uuidv4(),
        name: unitValues.name,
        address: {
          location: {
            coordinates: [
              coordinates?.lat ? coordinates?.lat : null,
              coordinates?.lng ? coordinates?.lng : null,
            ],
          },
          state: unitValues.state,
          city: unitValues.city,
          country: unitValues.country,
          pinCode: unitValues.pinCode,
          raw_address: unitValues.raw_address,
        },
        numberOfEmployees: unitValues.numberOfEmployees,
        unitType: unitValues.unitType,
        processIds: customProcessValue.map((values) => values.id),
        programIds: customProgramValue.map((values) => values.id),
        // documentsForVerification: "123456789",
      };

      setUnits((unit) => [unitObject, ...unit]);
      toast.success("Unit added successfully");
      unitValues.name = "";
      unitValues.state = "";
      unitValues.city = "";
      unitValues.country = "";
      unitValues.pinCode = "";
      unitValues.raw_address = "";
      unitValues.unitType = "";
      unitValues.numberOfEmployees = null;
      // setIsSecondChecked(false);
      setIsSecondChecked(false);
      setSelectedProcessValue([]);
      setCustomProcessValue([]);
      setSelectedProcessValue([]);
      setSelectedProgramValue([]);
    }
  };

  const saveEditChanges = () => {
    const selectedUnitIndex = units.findIndex(
      (unit) => selectedUnit.id === unit.id
    );

    if (selectedUnitIndex === -1) {
      console.error("Selected unit not found");
      return;
    }

    const updatedUnit = { ...selectedUnit };
    updatedUnit.processIds = customProcessValue.map((option) => option.value);

    const unitsCopy = [...units];
    unitsCopy.splice(selectedUnitIndex, 1, updatedUnit);

    setUnits(unitsCopy);
    setIsEditMode(false);

    if (toast) {
      toast.success("Product updated successfully");
    } else {
      console.error("Toast function not defined");
    }
  };

  const removeUnit = (id) => {
    const unit = units.filter((unit) => unit.id === id)[0];
    if (unit.unitType === "MAIN") {
      setUnitTypes([
        "MAIN",
        "FACILITY",
        "INTERNAL SUBCONTRACTOR",
        "EXTERNAL SUBCONTRACTOR",
      ]);
    }
    setUnits((prev) => prev.filter((unit) => unit.id !== id));
    toast.success("Unit removed successfully");
  };

  const [isOpen, setIsOpen] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState([]);

  const getProcessName = (processId) => {
    return processValues.filter((process) => process.id === processId)?.[0]
      ?.value;
  };

  const getProgramName = (programId) => {
    return programValues.filter((program) => program.id === programId)?.[0]
      ?.value;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <>
      <Box bg="#fff" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Flex>
          <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
            <Box
              as="span"
              borderRight={"3px solid #2272D5"}
              height="40px"
              marginRight={"1rem"}
            ></Box>
            Applicant Details
          </Text>
        </Flex>
        <Tooltip label="To automatically populate the organization details from the previous page, simply enable the checkbox.">
          <Box mt="1rem">
            <Checkbox
              paddingLeft={"3rem"}
              mt="1rem"
              variant="checkbox"
              fontSize="15px"
              isChecked={isSecondChecked}
              onChange={handleCheckboxChange}
            >
              Same details as Form 1
            </Checkbox>
          </Box>
        </Tooltip>
        <Box paddingLeft={{ base: "0", md: "3rem" }}>
          <Grid
            gap={"3rem"}
            templateColumns={{
              base: "1fr",
              md: "1fr",
              lg: "repeat(2, 1fr)",
            }}
            marginTop={"1rem"}
          >
            <GridItem colSpan={{ base: "2", md: "2", lg: "1" }}>
              <Box>
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent={"center"}
                >
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <Tooltip label="Kindly provide distinct names for each of your units.">
                      <GridItem width={"100%"}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Facility/Site Name{" "}
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Input
                          type="text"
                          id="unitName"
                          color={"#141D43"}
                          value={
                            isSecondChecked
                              ? values.organizationName
                              : unitValues.name
                          }
                          disabled={isSecondChecked ? true : ""}
                          border="2px solid  #8fd0fd !important"
                          _focusVisible={
                            rc2error1
                              ? {
                                  border: "1px solid red",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          // onChange={(e) => {
                          //   setUnitValues({
                          //     ...unitValues,
                          //     name: e.target.value,
                          //   });
                          //   setRc2Error1(false);
                          // }}
                          onChange={(e) => {
                            const newValue = isSecondChecked
                              ? values.organizationName
                              : e.target.value;
                            setUnitValues({
                              ...unitValues,
                              name: newValue,
                            });
                            setRc2Error1(false);
                          }}
                          marginTop="10px"
                          bg={"#fff"}
                          fontSize={"14px"}
                          _placeholder={{
                            opacity: 1,
                            color: " #464C64",
                            fontSize: "14px",
                          }}
                          className={rc2error1 ? "error" : ""}
                        />
                        {isSecondChecked
                          ? ""
                          : rc2error1 && (
                              <Box
                                className="error-message"
                                color={"red"}
                                mt="1rem"
                              >
                                Name is required
                              </Box>
                            )}
                      </GridItem>
                    </Tooltip>
                  </Grid>
                  <GridItem width={"100%"}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Address &nbsp;
                      <Text as="span" color="red">
                        *
                      </Text>
                    </Text>
                    <Input
                      type="text"
                      color={"#141D43"}
                      id="unitRawAddress"
                      marginTop="10px"
                      border="2px solid  #8fd0fd !important"
                      w="100%"
                      bg={"#fff"}
                      value={
                        isSecondChecked
                          ? values.organizationRawAddress
                          : unitValues.raw_address
                      }
                      disabled={isSecondChecked ? true : ""}
                      _focusVisible={
                        rc2error7
                          ? {
                              border: "1px solid red",
                            }
                          : { border: "1px solid #464C64" }
                      }
                      // onChange={(e) => {
                      //   setUnitValues({
                      //     ...unitValues,
                      //     raw_address: e.target.value,
                      //   });
                      //   setRc2Error1(false);
                      //   setUnitAddress(e.target.value);
                      // }}

                      onChange={(e) => {
                        const newValue = isSecondChecked
                          ? values.organizationRawAddress
                          : e.target.value;
                        setUnitValues({
                          ...unitValues,
                          raw_address: newValue,
                        });
                        setRc2Error7(false);
                        setUnitAddress(newValue);
                      }}
                      fontSize={"14px"}
                      _placeholder={{
                        opacity: 1,
                        color: " #464C64",
                        fontSize: "14px",
                      }}
                      className={rc2error1 ? "error" : ""}
                    />
                    {isSecondChecked
                      ? ""
                      : rc2error7 && (
                          <Box
                            className="error-message"
                            color={"red"}
                            mt="1rem"
                          >
                            Address is required
                          </Box>
                        )}
                  </GridItem>
                  {openSuggestions ? (
                    <Box width={"90%"} marginTop={"10px"}>
                      <Card
                        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                      >
                        <Box>
                          {suggestions?.map((suggestion) => (
                            <Box
                              mb={"1rem"}
                              mt={"1rem"}
                              ml={"2rem"}
                              onClick={() => {
                                setUnitValues({
                                  ...unitValues,
                                  raw_address: suggestion?.description,
                                });
                                setOpenSuggestions(false);
                              }}
                              _hover={{
                                background:
                                  "linear-gradient(90deg, rgba(81,187,255,1) 0%, rgba(81,187,255,1) 35%, rgba(164,206,255,1) 100%);",
                                cursor: "pointer",
                                color: "#fff",
                                pl: "10px",
                              }}
                            >
                              {suggestion?.description}
                            </Box>
                          ))}
                        </Box>
                      </Card>
                    </Box>
                  ) : (
                    ""
                  )}

                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Latitude
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="city"
                        bg={"#fff"}
                        opacity={"1 !important"}
                        border="2px solid  #8fd0fd !important"
                        value={coordinates?.lat ? coordinates?.lat : "N/A"}
                        disabled={true}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Longitude
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="city"
                        bg={"#fff"}
                        opacity={"1 !important"}
                        border="2px solid  #8fd0fd !important"
                        value={coordinates?.lng ? coordinates?.lng : "N/A"}
                        disabled={true}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                  </Grid>

                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        City
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="unitCity"
                        bg={"#fff"}
                        value={
                          isSecondChecked
                            ? values.organizationCity
                            : unitValues.city
                        }
                        disabled={isSecondChecked ? true : ""}
                        border="2px solid  #8fd0fd !important"
                        // onChange={(e) =>
                        //   setUnitValues({
                        //     ...unitValues,
                        //     city: e.target.value,
                        //   })
                        // }
                        onChange={(e) => {
                          const newValue = isSecondChecked
                            ? values.organizationCity
                            : e.target.value;
                          setUnitValues({
                            ...unitValues,
                            city: newValue,
                          });
                        }}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        State{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>
                      <Select
                        marginTop={"10px"}
                        bgColor="white"
                        id="unitState"
                        color={" #141D43"}
                        fontSize="sm"
                        value={
                          isSecondChecked
                            ? values.organizationState
                            : unitValues.state
                        }
                        disabled={isSecondChecked ? true : ""}
                        _focusVisible={
                          rc2error4
                            ? {
                                border: "1px solid red",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        border="2px solid  #8fd0fd !important"
                        // onChange={(e) => {
                        //   setUnitValues({
                        //     ...unitValues,
                        //     state: e.target.value,
                        //   });
                        //   setRc2Error4(false);
                        // }}
                        onChange={(e) => {
                          const newValue = isSecondChecked
                            ? values.organizationState
                            : e.target.value;
                          setUnitValues({
                            ...unitValues,
                            state: newValue,
                          });
                          setRc2Error4(false);
                        }}
                      >
                        <option hidden="true">Select State</option>
                        {statesList.map((state, index) => (
                          <option default="true" key={index}>
                            {state}
                          </option>
                        ))}
                      </Select>
                      {isSecondChecked
                        ? ""
                        : rc2error4 && (
                            <Box
                              className="error-message"
                              color={"red"}
                              mt="1rem"
                            >
                              State is required
                            </Box>
                          )}
                    </GridItem>
                  </Grid>
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Pincode
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="unitPinCode"
                        bg={"#fff"}
                        value={
                          isSecondChecked
                            ? values.organizationPinCode
                            : unitValues.pinCode
                        }
                        disabled={isSecondChecked ? true : ""}
                        border="2px solid  #8fd0fd !important"
                        // onChange={(e) =>
                        //   setUnitValues({
                        //     ...unitValues,
                        //     pinCode: e.target.value,
                        //   })
                        // }

                        onChange={(e) => {
                          const newValue = isSecondChecked
                            ? values.organizationPinCode
                            : e.target.value;
                          setUnitValues({
                            ...unitValues,
                            pinCode: newValue,
                          });
                        }}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                      {/* {errors.unitPinCode && touched.unitPinCode && (
                        <Box color="red.500">{errors.unitPinCode}</Box>
                      )} */}
                    </GridItem>
                    <GridItem>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Country
                      </Text>
                      <Input
                        type="text"
                        color={"#141D43"}
                        marginTop="10px"
                        id="unitCountry"
                        bg={"#fff"}
                        value={
                          isSecondChecked
                            ? values.organizationCountry
                            : unitValues.country
                        }
                        disabled={isSecondChecked ? true : ""}
                        border="2px solid  #8fd0fd !important"
                        // onChange={(e) =>
                        //   setUnitValues({
                        //     ...unitValues,
                        //     country: e.target.value,
                        //   })
                        // }
                        onChange={(e) => {
                          const newValue = isSecondChecked
                            ? values.organizationCountry
                            : e.target.value;
                          setUnitValues({
                            ...unitValues,
                            country: newValue,
                          });
                        }}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                      {/* {errors.unitCountry && touched.unitCountry && (
                        <Box color="red.500">{errors.unitCountry}</Box>
                      )} */}
                    </GridItem>
                  </Grid>
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <Tooltip label="Please select this field carefully because after adding unit you can't change it.">
                      <GridItem>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Type of unit{" "}
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>
                        <Select
                          marginTop={"10px"}
                          bgColor="white"
                          color={" #464C64"}
                          id="unitType"
                          border="2px solid  #8fd0fd !important"
                          fontSize="sm"
                          className={rc2error2 ? "error" : ""}
                          value={unitValues.unitType}
                          _focusVisible={
                            rc2error2
                              ? {
                                  border: "1px solid red",
                                }
                              : { border: "1px solid #464C64" }
                          }
                          onChange={(e) => {
                            setUnitValues({
                              ...unitValues,
                              unitType: e.target.value,
                            });
                            setRc2Error2(false);
                          }}
                        >
                          <option hidden="true">Select Unit Type</option>
                          {unitTypes.map((option) => (
                            <option default="true">{option}</option>
                          ))}
                        </Select>

                        {rc2error2 && (
                          <Box
                            className="error-message"
                            color={"red"}
                            mt={"1rem"}
                          >
                            Unit Type is required
                          </Box>
                        )}
                      </GridItem>
                    </Tooltip>
                  </Grid>
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Number of Employees{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>
                      <Input
                        type="number"
                        id="numberEmployee"
                        color={"#141D43"}
                        defaultValue={unitValues.numberOfEmployees}
                        value={
                          unitValues.numberOfEmployees === null
                            ? ""
                            : unitValues.numberOfEmployees
                        }
                        border="2px solid  #8fd0fd !important"
                        min="1"
                        className={rc2error3 ? "error" : ""}
                        _focusVisible={
                          rc2error3
                            ? {
                                border: "1px solid red",
                              }
                            : { border: "1px solid #464C64" }
                        }
                        onChange={(e) => {
                          setUnitValues({
                            ...unitValues,
                            numberOfEmployees: parseInt(e.target.value),
                          });
                          setRc2Error3(false);
                        }}
                        marginTop="10px"
                        bg={"#fff"}
                        fontSize={"14px"}
                        _placeholder={{
                          opacity: 1,
                          color: " #464C64",
                          fontSize: "14px",
                        }}
                      />
                      {rc2error3 && (
                        <Box
                          className="error-message"
                          color={"red"}
                          mt={"1rem"}
                        >
                          Number of employees should be greater than 0
                        </Box>
                      )}
                    </GridItem>
                  </Grid>
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        Type of Processes{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </Text>

                      <MultiSelect
                        marginTop={"10px"}
                        options={processValues}
                        value={selectedProcessValue}
                        bgColor="white"
                        color={" #464C64"}
                        toggleAllCheckboxVisibility="always"
                        border="2px solid  #8fd0fd !important"
                        onChange={(value) => {
                          const newArr = value.map(
                            (value) =>
                              processValues.filter(
                                (process) => process.label === value
                              )[0]
                          );
                          setCustomProcessValue(newArr);
                          setSelectedProcessValue(value);
                          setRc2Error5(false);
                        }}
                      />
                      {rc2error5 && (
                        <Box className="error-message" color={"red"} mt="1rem">
                          Atleast one process is required
                        </Box>
                      )}
                    </GridItem>
                  </Grid>
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <Tooltip label="Please select this field carefully because after adding unit you can't change it.">
                      <GridItem width={"100%"}>
                        <Text
                          color={"#141D43"}
                          fontSize="md"
                          fontWeight={"700"}
                          fontFamily={"font.roboto"}
                        >
                          Please Select program(s) you want to have this unit
                          certified for.{" "}
                          <Text as="span" color="red">
                            *
                          </Text>
                        </Text>

                        <MultiSelect
                          marginTop={"10px"}
                          options={programValues}
                          value={selectedProgramValue}
                          bgColor="white"
                          toggleAllCheckboxVisibility="always"
                          color={" #464C64"}
                          onChange={(value) => {
                            const newArr = value.map(
                              (value) =>
                                programValues.filter(
                                  (program) => program.label === value
                                )[0]
                            );
                            setCustomProgramValue(newArr);
                            setSelectedProgramValue(value);
                            setRc2Error6(false);
                          }}
                        />
                        {rc2error6 && (
                          <Box
                            className="error-message"
                            color={"red"}
                            mt="1rem"
                          >
                            Atleast one program is required
                          </Box>
                        )}
                      </GridItem>
                    </Tooltip>
                  </Grid>
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="md"
                        fontWeight={"700"}
                        fontFamily={"font.roboto"}
                      >
                        To add more units please click add unit button below
                      </Text>
                      <Button
                        bg={"#52BBFF"}
                        _hover={{ bg: "#3fa7eb" }}
                        color="white"
                        cursor={"pointer"}
                        onClick={() => addUnits(unitValues)}
                      >
                        Add Unit
                      </Button>
                    </GridItem>
                  </Grid>
                </Box>
              </Box>
            </GridItem>
            <GridItem
              colSpan={{ base: "2", md: "2", lg: "1" }}
              height={{
                base: "auto",
                md: "auto",
                lg: "calc(100vh - 10px)",
              }}
              overflowY={units?.length > 3 ? "scroll" : "auto"}
              className="overflow-style"
              borderLeft={{ base: "", md: "", lg: "3px solid #52BBFF" }}
              paddingLeft={{ base: "", md: "", lg: "2rem" }}
            >
              <Box>
                <Box
                  display={"flex"}
                  flexDirection="column"
                  alignItems="flex-start"
                  justifyContent={"center"}
                >
                  <Grid
                    width={"100%"}
                    templateColumns="repeat(1, 1fr)"
                    my={"1rem"}
                    gap="3rem"
                  >
                    <GridItem width={"100%"}>
                      <Text
                        color={"#141D43"}
                        fontSize="lg"
                        fontWeight={"800"}
                        marginBottom="5px"
                      >
                        List of Units added
                      </Text>
                      <Box
                        border={"2px solid #2272D5"}
                        width="15%"
                        marginBottom={"1rem"}
                      ></Box>
                      {units?.length > 0 ? (
                        units?.map((data) => (
                          <Card
                            w={"100%"}
                            height="150px"
                            backgroundColor={"#fff"}
                            mb="1.5rem"
                            boxShadow={
                              "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
                            }
                            marginTop="7px"
                          >
                            <Box padding={"1rem"}>
                              <Box>
                                <Box
                                  display={"flex"}
                                  justifyContent="space-between"
                                >
                                  <Text color={"#2272D5"} fontWeight={"600"}>
                                    Unit Details
                                  </Text>
                                  <Box
                                    onClick={() => removeUnit(data?.id)}
                                    cursor="pointer"
                                  >
                                    <TiDelete
                                      fontSize={"28px"}
                                      color="crimson"
                                    />
                                  </Box>
                                </Box>
                                <Grid
                                  width={"100%"}
                                  templateColumns="repeat(4, 1fr)"
                                  my={"1rem"}
                                  gap="10px"
                                >
                                  <GridItem colSpan={2}>
                                    <Text
                                      color={"#141D43"}
                                      fontSize={{
                                        base: "sm",
                                        lg: "sm",
                                        xl: "md",
                                      }}
                                      fontWeight={"800"}
                                    >
                                      Facility/Site Name
                                    </Text>
                                    <Text color={"#141D43"} fontSize="md">
                                      {data.name ? data.name : "N/A"}
                                    </Text>
                                  </GridItem>
                                  <GridItem colSpan={1}>
                                    <Text
                                      color={"#141D43"}
                                      fontSize={{
                                        base: "sm",
                                        lg: "sm",
                                        xl: "sm",
                                      }}
                                      fontWeight={"800"}
                                    >
                                      Type of Unit
                                    </Text>
                                    <Text color={"#141D43"} fontSize="md">
                                      {data.unitType ? data.unitType : "N/A"}
                                    </Text>
                                  </GridItem>
                                  <GridItem colSpan={1}>
                                    <Tooltip label="View Unit Details!">
                                      <Button
                                        bg="#FFFFFF"
                                        mx="1rem"
                                        onClick={() => {
                                          setSelectedUnit(data);
                                          setIsOpen(true);
                                        }}
                                        leftIcon={<EyeIcon />}
                                      ></Button>
                                    </Tooltip>
                                  </GridItem>
                                </Grid>
                              </Box>
                            </Box>
                          </Card>
                        ))
                      ) : (
                        <Box marginTop={"3rem"}>
                          <Text
                            color={"#141D43"}
                            fontSize="lg"
                            fontWeight={"800"}
                          >
                            Added unit cards will appear here
                          </Text>
                        </Box>
                      )}
                    </GridItem>
                  </Grid>
                </Box>
              </Box>
            </GridItem>
          </Grid>
        </Box>
      </Box>
      {/* Modal */}

      <Modal
        isOpen={isOpen}
        onClose={() => {
          setIsOpen(false);
          setIsEditMode(false);
        }}
      >
        <ModalOverlay />
        <ModalContent>
          <Grid
            templateColumns={{ base: "repeat(2,1fr)", md: "repeat(2,1fr)" }}
            gap={2}
          >
            <GridItem>
              <ModalHeader color="#2272D5">Unit Details</ModalHeader>
            </GridItem>
            <GridItem>
              <Button
                bg="#ffffff"
                mt="0.7rem"
                ml="10rem"
                leftIcon={<RemoveIcon />}
                onClick={() => {
                  setSelectedUnit([]);
                  setIsOpen(false);
                }}
              ></Button>
            </GridItem>
          </Grid>
          <ModalBody>
            <Box>
              <Text color={"#141D43"} fontWeight={"800"}>
                Facility/Site Name
              </Text>
              {!isEditMode ? (
                <Text>{selectedUnit?.name ? selectedUnit?.name : "N/A"}</Text>
              ) : (
                <Input
                  value={selectedUnit.name}
                  onChange={(e) =>
                    setSelectedUnit({ ...selectedUnit, name: e.target.value })
                  }
                />
              )}
              <Text mt="2rem" color={"#141D43"} fontWeight={"800"}>
                {" "}
                Address
              </Text>
              {!isEditMode ? (
                <Text>
                  {selectedUnit?.address?.raw_address
                    ? selectedUnit?.address?.raw_address
                    : "N/A"}
                </Text>
              ) : (
                <Input
                  value={selectedUnit.address?.raw_address}
                  onChange={(e) =>
                    setSelectedUnit({
                      ...selectedUnit,
                      address: {
                        ...selectedUnit.address,
                        raw_address: e.target.value,
                        country: selectedUnit.address?.country,
                        pinCode: selectedUnit.address?.pinCode,
                        city: selectedUnit.address?.city,
                        state: selectedUnit.address?.state,
                      },
                    })
                  }
                />
              )}

              <Grid
                mt="2rem"
                templateColumns={{ base: "1fr", md: "repeat(2,1fr)" }}
                gap={2}
              >
                <GridItem>
                  <Text color={"#141D43"} fontWeight={"800"}>
                    City
                  </Text>
                  {!isEditMode ? (
                    <Text>
                      {selectedUnit?.address?.city
                        ? selectedUnit?.address?.city
                        : "N/A"}
                    </Text>
                  ) : (
                    <Input
                      value={selectedUnit.address?.city}
                      onChange={(e) =>
                        setSelectedUnit({
                          ...selectedUnit,
                          address: {
                            ...selectedUnit.address,
                            city: e.target.value,
                            country: selectedUnit.address?.country,
                            pinCode: selectedUnit.address?.pinCode,
                            raw_address: selectedUnit.address?.raw_address,
                            state: selectedUnit.address?.state,
                          },
                        })
                      }
                    />
                  )}
                </GridItem>
                <GridItem>
                  <Text color={"#141D43"} fontWeight={"800"}>
                    State
                  </Text>
                  {!isEditMode ? (
                    <Text>
                      {selectedUnit?.address?.state
                        ? selectedUnit?.address?.state
                        : "N/A"}
                    </Text>
                  ) : (
                    <Select
                      bgColor="white"
                      id="unitState"
                      color={" #141D43"}
                      fontSize="sm"
                      value={selectedUnit.address?.state}
                      border="2px solid  #8fd0fd !important"
                      onChange={(e) =>
                        setSelectedUnit({
                          ...selectedUnit,
                          address: {
                            ...selectedUnit.address,
                            state: e.target.value,
                            pinCode: selectedUnit.address?.pinCode,
                            city: selectedUnit.address?.city,
                            raw_address: selectedUnit.address?.raw_address,
                            country: selectedUnit.address?.country,
                          },
                        })
                      }
                    >
                      <option hidden="true">Select State</option>
                      {statesList.map((state, index) => (
                        <option default="true" key={index}>
                          {state}
                        </option>
                      ))}
                    </Select>
                  )}
                </GridItem>
              </Grid>
              <Grid
                mt="2rem"
                templateColumns={{ base: "1fr", md: "repeat(2,1fr)" }}
                gap={2}
              >
                <GridItem>
                  <Text color={"#141D43"} fontWeight={"800"}>
                    Pincode
                  </Text>
                  {!isEditMode ? (
                    <Text>
                      {selectedUnit?.address?.pinCode
                        ? selectedUnit?.address?.pinCode
                        : "N/A"}
                    </Text>
                  ) : (
                    <Input
                      value={selectedUnit.address?.pinCode}
                      onChange={(e) =>
                        setSelectedUnit({
                          ...selectedUnit,
                          address: {
                            ...selectedUnit.address,
                            pinCode: e.target.value,
                            city: selectedUnit.address?.city,
                            raw_address: selectedUnit.address?.raw_address,
                            state: selectedUnit.address?.state,
                            country: selectedUnit.address?.country,
                          },
                        })
                      }
                    />
                  )}
                </GridItem>
                <GridItem>
                  <Text color={"#141D43"} fontWeight={"800"}>
                    Country
                  </Text>
                  {!isEditMode ? (
                    <Text>
                      {selectedUnit?.address?.country
                        ? selectedUnit?.address?.country
                        : "N/A"}
                    </Text>
                  ) : (
                    <Input
                      value={selectedUnit.address?.country}
                      onChange={(e) =>
                        setSelectedUnit({
                          ...selectedUnit,
                          address: {
                            ...selectedUnit.address,
                            country: e.target.value,
                            pinCode: selectedUnit.address?.pinCode,
                            city: selectedUnit.address?.city,
                            raw_address: selectedUnit.address?.raw_address,
                            state: selectedUnit.address?.state,
                          },
                        })
                      }
                    />
                  )}
                </GridItem>
              </Grid>
              <Text mt="2rem" color={"#141D43"} fontWeight={"800"}>
                Type of Unit
              </Text>
              <Text>
                {selectedUnit?.unitType ? selectedUnit?.unitType : "N/A"}
              </Text>
              <Text mt="2rem" color={"#141D43"} fontWeight={"800"}>
                Number of Employees
              </Text>
              {!isEditMode ? (
                <Text>
                  {selectedUnit?.numberOfEmployees
                    ? selectedUnit?.numberOfEmployees
                    : "N/A"}
                </Text>
              ) : (
                <Input
                  value={selectedUnit.numberOfEmployees}
                  onChange={(e) =>
                    setSelectedUnit({
                      ...selectedUnit,
                      numberOfEmployees: e.target.value,
                    })
                  }
                />
              )}

              <Text mt="2rem" color={"#141D43"} fontWeight={"800"}>
                Type of Process
              </Text>
              {!isEditMode ? (
                <Text>
                  {selectedUnit?.processIds?.length > 0
                    ? selectedUnit?.processIds?.map((processId, index) => (
                        <Text key={index}>{getProcessName(processId)}</Text>
                      ))
                    : "N/A"}
                </Text>
              ) : (
                <MultiSelect
                  marginTop={"10px"}
                  options={processValues}
                  // value={selectedUnitProcess}
                  value={selectedUnit?.processIds?.map((processId) => {
                    const matchingProcess = processValues.find(
                      (process) => process.id === processId
                    );
                    return matchingProcess ? matchingProcess.label : "";
                  })}
                  bgColor="white"
                  color={" #464C64"}
                  toggleAllCheckboxVisibility="always"
                  border="2px solid  #8fd0fd !important"
                  // onChange={(value) => {
                  //   const newArr = value.map((value) => {
                  //     const process = processValues.find(
                  //       (process) => process.label === value
                  //     );
                  //     return {
                  //       label: process.label,
                  //       value: process.id,
                  //     };
                  //   });

                  //   const processIds = newArr.map((option) => option.value);

                  //   const updatedUnit = units
                  //     .filter((unit) => unit.id === selectedUnit.id)
                  //     .map((unit) => ({ ...unit, processIds }))[0];

                  //   const updatedUnits = units.map((unit) => {
                  //     if (unit.id === selectedUnit.id) {
                  //       return updatedUnit;
                  //     }
                  //     return unit;
                  //   });

                  //   setCustomProcessValue(newArr);
                  //   setSelectedUnitProcess(value);
                  //   setUnits(updatedUnits);
                  // }}
                  onChange={(value) => {
                    const newArr = value.map((value) => {
                      const process = processValues.find(
                        (process) => process.label === value
                      );
                      return {
                        label: process.label,
                        value: process.id,
                      };
                    });
                    setCustomProcessValue(newArr);
                    setSelectedUnitProcess(value);

                    const processIds = newArr.map((option) => option.value);

                    setSelectedUnit((prevSelectedUnit) => {
                      return {
                        ...prevSelectedUnit,
                        processIds: processIds,
                      };
                    });
                  }}
                />
              )}

              <Text mt="2rem" color={"#141D43"} fontWeight={"800"}>
                Programs
              </Text>
              <Text>
                {selectedUnit?.programIds?.length > 0
                  ? selectedUnit?.programIds?.map((programId, index) => (
                      <Text key={index}>{getProgramName(programId)}</Text>
                    ))
                  : "N/A"}
              </Text>
            </Box>
          </ModalBody>
          <ModalFooter>
            {!isEditMode ? (
              <Button
                bg="#2272D5"
                color="#ffffff"
                _hover={{ backgroundColor: "#2272D5" }}
                onClick={() => setIsEditMode(true)}
              >
                Edit
              </Button>
            ) : (
              <>
                <Button
                  bg="#2272D5"
                  _hover={{ backgroundColor: "#2272D5" }}
                  color="#ffffff"
                  onClick={() => saveEditChanges()}
                >
                  Save
                </Button>
                <Button
                  bg="#C4C4C4"
                  _hover={{ backgroundColor: "#C4C4C4" }}
                  color="#ffffff"
                  ml="1rem"
                  onClick={() => {
                    setIsEditMode(false);
                    setIsOpen(false);
                  }}
                >
                  Cancel
                </Button>
              </>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default RcForm2;
